/* Suggestions de stickers dans le tiroir panier — Maison Stickers Muraux.
   Ordinateur (900 px et plus) : colonne à gauche du panier. Mobile : rangée qui défile sous les articles.
   Produits : recommandations Shopify du dernier sticker ajouté, à taille unique seulement, sans ceux
   déjà au panier (données : sections/msm-reco-panier.liquid).
   Fiche détaillée sans quitter le panier, comme l'ancien choix des stickers offerts :
   au survol sur ordinateur (aperçu posé à côté), au clic ou au doigt (fenêtre avec « Ajouter au panier »).
   Le panier (#msmCartMount) est redessiné à chaque changement : le bloc se réinsère tout seul. */
(function () {
  var T = (window.msmSug && window.msmSug.txt) || {};
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var GRAND = window.matchMedia('(min-width: 900px)');
  var SOURIS = window.matchMedia('(hover: hover) and (pointer: fine)');
  var signature = null, produits = [], enCours = false;
  /* Suggestions déjà calculées, par contenu du panier : la colonne s'affiche sans attendre. */
  var cache = {}, dernier = null;
  var fiche = null, ficheIndex = -1, minuteur = null;
  /* Image affichée dans la fiche et grandes images déjà demandées au navigateur. */
  var ficheImage = 0, prechargees = [];

  function echapper(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function carte(p, i) {
    return '<div class="msm-sug__carte" data-i="' + i + '">' +
      '<button type="button" class="msm-sug__ouvrir msm-sug__lien" data-i="' + i + '" tabindex="-1" aria-hidden="true">' +
        (p.img ? '<img class="msm-sug__img" src="' + echapper(p.img) + '" alt="" loading="lazy">' : '<span class="msm-sug__img"></span>') +
      '</button>' +
      '<button type="button" class="msm-sug__ouvrir msm-sug__nom" data-i="' + i + '">' + echapper(p.t) + '</button>' +
      (p.taille ? '<p class="msm-sug__taille">' + echapper(p.taille) + '</p>' : '') +
      '<div class="msm-sug__bas"><span class="msm-sug__prix">' + echapper(p.p) + '</span>' +
        '<button type="button" class="msm-sug__btn" data-vid="' + p.vid + '" aria-label="' + echapper(T.ajouter) + ' : ' + echapper(p.t) + '">+</button>' +
      '</div>' +
    '</div>';
  }

  /* Articles du panier (poignées triées) : sert à savoir si quelque chose a changé. */
  function cle(handles) { return handles.slice().sort().join(','); }
  function lireSignature(scroll) {
    return cle(Array.prototype.map.call(scroll.querySelectorAll('[data-h]'), function (el) { return el.getAttribute('data-h'); }));
  }

  function charger() {
    enCours = true;
    var pour = null;
    return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        pour = cle(cart.items.map(function (i) { return i.handle; }));
        var dans = cart.items.map(function (i) { return i.product_id; });
        var base = cart.items.filter(function (i) { return !/prioritaire/.test(i.handle); })[0];
        if (!base) return [];
        return fetch(ROOT + 'recommendations/products?product_id=' + base.product_id + '&limit=10&section_id=msm-reco-panier')
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (html) {
            var m = html.match(/<script type="application\/json" data-msm-reco>([\s\S]*?)<\/script>/);
            var liste = [];
            try { liste = m ? JSON.parse(m[1]) : []; } catch (e) { liste = []; }
            return liste.filter(function (p) { return dans.indexOf(p.id) < 0; }).slice(0, 6);
          });
      })
      .catch(function () { return []; })
      .then(function (liste) {
        if (pour !== null) cache[pour] = liste;
        enCours = false;
        /* Le panier a pu changer pendant le chargement : on recharge une fois pour le panier actuel. */
        if (pour !== null && signature !== null && pour !== signature && pour !== dernier) {
          dernier = pour;
          charger();
          return;
        }
        dernier = pour;
        produits = liste;
        /* Grande image de chaque fiche chargée d'avance : elle est prête au survol. */
        produits.forEach(function (p) { if (p.imgs && p.imgs[0]) (new Image()).src = p.imgs[0]; });
        placer();
      });
  }

  function placer() {
    var mount = document.getElementById('msmCartMount');
    if (!mount) return;
    var scroll = mount.querySelector('.msm-cart__scroll');
    var bloc = document.getElementById('msmSug');
    if (!scroll || !scroll.querySelector('.msm-cart__item')) {
      if (bloc) bloc.remove();
      signature = null;
      return;
    }
    var sig = lireSignature(scroll);
    if (sig !== signature) {
      signature = sig;
      if (cache[sig]) {
        produits = cache[sig];
      } else {
        if (!enCours) charger();
        return;
      }
    }
    if (!produits.length) {
      if (bloc) bloc.remove();
      return;
    }
    var html = '<p class="msm-sug__titre">' + echapper(T.titre) + '</p><div class="msm-sug__liste">' + produits.map(carte).join('') + '</div>';
    if (!bloc) {
      bloc = document.createElement('div');
      bloc.id = 'msmSug';
      bloc.addEventListener('click', clic);
      bloc.addEventListener('mouseover', survol);
      bloc.addEventListener('mouseleave', function () { clearTimeout(minuteur); if (fiche && fiche.classList.contains('is-survol')) fermer(); });
    }
    if (bloc.dataset.html !== html) {
      bloc.innerHTML = html;
      bloc.dataset.html = html;
    }
    var cote = GRAND.matches;
    var classe = 'msm-sug ' + (cote ? 'msm-sug--cote' : 'msm-sug--rang');
    if (bloc.className !== classe) bloc.className = classe;
    var parent = cote ? mount : scroll;
    if (bloc.parentNode !== parent || (!cote && bloc !== scroll.lastElementChild)) parent.appendChild(bloc);
  }

  /* ---------- Ajout au panier ---------- */
  function ajouterVariante(vid, btn, apres) {
    if (btn) btn.classList.add('is-loading');
    /* Le moteur du panier surveille /cart/add et se redessine tout seul. */
    return fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1 }] })
    }).catch(function () {}).then(function () {
      if (btn) btn.classList.remove('is-loading');
      if (apres) apres();
    });
  }

  function clic(e) {
    var btn = e.target.closest('.msm-sug__btn[data-vid]');
    if (btn) { e.preventDefault(); fermer(); ajouterVariante(btn.getAttribute('data-vid'), btn); return; }
    var ouvrir = e.target.closest('.msm-sug__ouvrir');
    if (ouvrir) { e.preventDefault(); clearTimeout(minuteur); montrer(Number(ouvrir.getAttribute('data-i')), null); }
  }

  /* ---------- Fiche détaillée ---------- */
  function creerFiche() {
    fiche = document.createElement('div');
    fiche.className = 'msm-sugf';
    fiche.hidden = true;
    fiche.innerHTML =
      '<div class="msm-sugf__panel" role="dialog" aria-modal="true" aria-labelledby="msmSugfT">' +
        '<button type="button" class="msm-sugf__close" aria-label="' + echapper(T.fermer) + '">&#10005;</button>' +
        '<div class="msm-sugf__media"><img class="msm-sugf__main" src="" alt=""><div class="msm-sugf__thumbs"></div></div>' +
        '<div class="msm-sugf__info">' +
          '<p class="msm-sugf__label"></p>' +
          '<p class="msm-sugf__titre" id="msmSugfT"></p>' +
          '<p class="msm-sugf__prix"></p>' +
          '<p class="msm-sugf__taille"></p>' +
          '<div class="msm-sugf__chips"></div>' +
          '<p class="msm-sugf__desc"></p>' +
          '<button type="button" class="msm-sugf__ajout"></button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(fiche);
    fiche.addEventListener('click', function (e) {
      if (e.target === fiche || e.target.closest('.msm-sugf__close')) { fermer(); return; }
      var vignette = e.target.closest('.msm-sugf__thumbs img');
      if (vignette) {
        afficher(Number(vignette.getAttribute('data-k')));
        return;
      }
      var ajout = e.target.closest('.msm-sugf__ajout');
      if (ajout && produits[ficheIndex]) {
        ajout.textContent = T.ajoute;
        ajouterVariante(produits[ficheIndex].vid, ajout, function () { setTimeout(fermer, 350); });
      }
    });
    /* Échap ferme la fiche seule, pas le panier derrière elle. */
    window.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && fiche && !fiche.hidden) { e.stopImmediatePropagation(); fermer(); }
    }, true);
    /* Au doigt : glisser sur la grande image passe à la suivante ou à la précédente. */
    var principale = fiche.querySelector('.msm-sugf__main'), x0 = null, y0 = 0;
    principale.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
    principale.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
      x0 = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) afficher(ficheImage + (dx < 0 ? 1 : -1));
    }, { passive: true });
  }

  /* Change l'image de la fiche sans attendre (27/10/2026, sur mobile le passage d'une image à l'autre
     était très lent) : si la grande image n'est pas encore arrivée, la vignette déjà chargée la remplace
     le temps du téléchargement, puis la grande prend sa place. */
  function afficher(k) {
    var vignettes = fiche.querySelectorAll('.msm-sugf__thumbs img');
    if (!vignettes.length) return;
    k = (k + vignettes.length) % vignettes.length;
    ficheImage = k;
    var principale = fiche.querySelector('.msm-sugf__main');
    var grand = vignettes[k].getAttribute('data-grand');
    var pre = prechargees[k];
    if (pre && pre.complete && pre.naturalWidth) {
      principale.src = grand;
    } else {
      principale.src = vignettes[k].src;
      if (pre) pre.addEventListener('load', function () { if (ficheImage === k && !fiche.hidden) principale.src = grand; }, { once: true });
    }
    vignettes.forEach(function (im, i) { im.classList.toggle('is-on', i === k); });
  }

  function montrer(i, carteSurvolee) {
    var p = produits[i];
    if (!p) return;
    if (!fiche) creerFiche();
    ficheIndex = i;
    var imgs = p.imgs && p.imgs.length ? p.imgs : [p.img];
    fiche.querySelector('.msm-sugf__main').src = imgs[0] || '';
    fiche.querySelector('.msm-sugf__thumbs').innerHTML = imgs.length > 1 ? imgs.map(function (src, k) {
      return '<img src="' + echapper(src.replace(/width=\d+/, 'width=140')) + '" data-grand="' + echapper(src) + '" data-k="' + k + '" alt=""' + (k === 0 ? ' class="is-on"' : '') + '>';
    }).join('') : '';
    /* Toutes les grandes images du produit demandées dès l'ouverture de la fiche, pas au toucher de la vignette. */
    ficheImage = 0;
    prechargees = carteSurvolee ? [] : imgs.map(function (src) { var im = new Image(); im.decoding = 'async'; im.src = src; return im; });
    fiche.querySelector('.msm-sugf__label').textContent = T.titre || '';
    fiche.querySelector('.msm-sugf__titre').textContent = p.t;
    fiche.querySelector('.msm-sugf__prix').innerHTML = echapper(p.p) + (p.c ? ' <s>' + echapper(p.c) + '</s>' : '');
    var taille = fiche.querySelector('.msm-sugf__taille');
    taille.textContent = p.taille || '';
    taille.hidden = !p.taille;
    fiche.querySelector('.msm-sugf__chips').innerHTML = (p.chips || []).map(function (c) { return '<span class="msm-sugf__chip">' + echapper(c) + '</span>'; }).join('');
    fiche.querySelector('.msm-sugf__desc').textContent = p.d || '';
    var ajout = fiche.querySelector('.msm-sugf__ajout');
    ajout.textContent = T.ajouter;
    ajout.classList.remove('is-loading');

    var survolee = !!carteSurvolee;
    fiche.classList.toggle('is-survol', survolee);
    var panel = fiche.querySelector('.msm-sugf__panel');
    panel.style.top = panel.style.right = '';
    fiche.hidden = false;
    if (survolee) {
      /* Aperçu posé à gauche de la colonne, à la hauteur de la vignette survolée. */
      var colonne = document.getElementById('msmSug').getBoundingClientRect();
      var r = carteSurvolee.getBoundingClientRect();
      var h = panel.offsetHeight;
      panel.style.right = Math.round(window.innerWidth - colonne.left + 12) + 'px';
      panel.style.top = Math.round(Math.max(12, Math.min(r.top, window.innerHeight - h - 12))) + 'px';
    }
    requestAnimationFrame(function () { fiche.classList.add('is-open'); });
    if (!survolee) fiche.querySelector('.msm-sugf__close').focus({ preventScroll: true });
  }

  function fermer() {
    clearTimeout(minuteur);
    if (!fiche || fiche.hidden) return;
    fiche.classList.remove('is-open');
    fiche.hidden = true;
    ficheIndex = -1;
  }

  function survol(e) {
    if (!SOURIS.matches || !GRAND.matches) return;
    /* Panier fermé ou en train de se refermer : pas d'aperçu (27/10/2026, aperçu resté affiché sur la page). */
    var mount = document.getElementById('msmCartMount');
    if (!mount || !mount.classList.contains('is-open')) return;
    var c = e.target.closest('.msm-sug__carte');
    if (!c) return;
    if (fiche && !fiche.hidden && !fiche.classList.contains('is-survol')) return;
    var i = Number(c.getAttribute('data-i'));
    if (i === ficheIndex && fiche && !fiche.hidden) return;
    /* Sans délai : la fiche apparaît dès que la souris arrive sur la vignette (24/10/2026). */
    clearTimeout(minuteur);
    montrer(i, c);
  }

  /* Filet de sécurité : l'aperçu de survol se ferme dès que la souris passe ailleurs que sur la colonne.
     Le « mouseleave » de la colonne ne part pas toujours : quand le panier se redessine sous la souris,
     la colonne est retirée puis remise, et le navigateur ne la considère plus comme survolée. */
  function survolHors(e) {
    if (!fiche || fiche.hidden || !fiche.classList.contains('is-survol')) return;
    if (!(e.target.closest && e.target.closest('#msmSug'))) fermer();
  }

  /* ---------- Produits du panier : image agrandie au survol (ordinateur) ----------
     Posée à gauche du panier (ou de la colonne des suggestions), à la hauteur de l'article.
     Même fichier image que la vignette : déjà chargé, l'agrandissement est immédiat. */
  var zoom = null;
  function zoomCacher() { if (zoom) zoom.hidden = true; }
  function zoomSurvol(e) {
    var lien = SOURIS.matches && GRAND.matches && e.target.closest && e.target.closest('#msmCartMount .msm-cart__imglink');
    var img = lien && lien.querySelector('img');
    if (!img || !img.getAttribute('src')) { zoomCacher(); return; }
    if (!zoom) {
      zoom = document.createElement('div');
      zoom.className = 'msm-cartzoom';
      zoom.setAttribute('aria-hidden', 'true');
      zoom.innerHTML = '<img alt="">';
      document.body.appendChild(zoom);
    }
    var z = zoom.querySelector('img');
    if (z.getAttribute('src') !== img.getAttribute('src')) z.setAttribute('src', img.getAttribute('src'));
    var colonne = document.getElementById('msmSug');
    var panneau = document.querySelector('#msmCartMount .msm-cart');
    var bord = colonne && colonne.getClientRects().length ? colonne : panneau;
    var r = lien.getBoundingClientRect();
    zoom.hidden = false;
    var h = zoom.offsetHeight;
    zoom.style.right = Math.round(window.innerWidth - (bord ? bord.getBoundingClientRect().left : r.left) + 12) + 'px';
    zoom.style.top = Math.round(Math.max(12, Math.min(r.top + r.height / 2 - h / 2, window.innerHeight - h - 12))) + 'px';
  }

  function demarrer() {
    /* Toute la page est surveillée : au démarrage, le moteur du panier remplace son conteneur
       (#msmCartMount), et un observateur posé sur l'ancien ne verrait plus rien. */
    var cible = document.body;
    var raf = null;
    new MutationObserver(function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        placer();
        var mount = document.getElementById('msmCartMount');
        if (!mount || !mount.classList.contains('is-open')) { fermer(); zoomCacher(); }
      });
    }).observe(cible, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    document.addEventListener('mouseover', zoomSurvol);
    document.addEventListener('mouseover', survolHors);
    document.addEventListener('scroll', zoomCacher, true);
    if (GRAND.addEventListener) GRAND.addEventListener('change', function () { fermer(); placer(); });
    placer();
    /* Préparées dès le chargement de la page quand le panier contient déjà des stickers :
       la colonne est prête à l'ouverture du panier. */
    setTimeout(function () { if (!enCours) charger(); }, 800);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
  else demarrer();
})();
